export default {
  baseUrl: process.env.REACT_APP_BASE_URL,
  loginUrl: process.env.REACT_APP_LOGIN_URL,
  accountGA: process.env.REACT_APP_ACCOUNT_GA,
  enableGA: process.env.REACT_APP_ENABLE_GOOGLE_ANALYTICS,
  paths: {
    transfer: "/transfer",
    pending: "/pending",
    prevalidated: "/prevalidated",
    conciliated: "/conciliated",
    proposal: "/proposal",
    current: "/user/current",
    user: "/user",
    item: "/item",
    files: "/files",
    searchClients: "/client/search"
  }
};
